var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenCaptureVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4384_29992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 3C16.8745 3 14.2486 3.16533 12.0841 3.64637C9.90068 4.13162 8.08592 4.96 6.68995 6.35597C5.29398 7.75193 4.4656 9.5667 3.98035 11.7501C3.49932 13.9146 3.33398 16.5405 3.33398 19.6667C3.33398 22.7928 3.49932 25.4187 3.98035 27.5832C4.4656 29.7667 5.29398 31.5813 6.68995 32.9773C8.08592 34.3733 9.90068 35.2017 12.0841 35.687C14.2486 36.168 16.8745 36.3333 20.0007 36.3333C23.1268 36.3333 25.7527 36.168 27.9172 35.687C30.1007 35.2017 31.9153 34.3733 33.3113 32.9773C34.7073 31.5813 35.5357 29.7667 36.021 27.5832C36.502 25.4187 36.6673 22.7928 36.6673 19.6667C36.6673 16.5405 36.502 13.9146 36.021 11.7501C35.5357 9.5667 34.7073 7.75193 33.3113 6.35597C31.9153 4.96 30.1007 4.13162 27.9172 3.64637C25.7527 3.16533 23.1268 3 20.0007 3Z",
    fill: "url(#paint0_linear_4384_29992)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4384_29992)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0007 4C16.8974 4 14.3581 4.1654 12.301 4.62255C10.2363 5.08142 8.61713 5.843 7.39706 7.06307C6.17699 8.28314 5.4154 9.90235 4.95654 11.9671C4.49939 14.0241 4.33398 16.5634 4.33398 19.6667C4.33398 22.7699 4.49939 25.3092 4.95653 27.3662L3.98035 27.5832C3.49932 25.4187 3.33398 22.7928 3.33398 19.6667C3.33398 16.5405 3.49932 13.9146 3.98035 11.7501C4.4656 9.5667 5.29398 7.75193 6.68995 6.35597C8.08592 4.96 9.90068 4.13162 12.0841 3.64637C14.2486 3.16533 16.8745 3 20.0007 3C23.1268 3 25.7527 3.16533 27.9172 3.64637L27.7002 4.62255C25.6432 4.1654 23.1039 4 20.0007 4ZM35.0448 11.9671C34.5859 9.90234 33.8243 8.28314 32.6042 7.06308C31.3841 5.843 29.765 5.08142 27.7002 4.62255L27.9172 3.64637C30.1007 4.13162 31.9153 4.96 33.3113 6.35597C34.7073 7.75193 35.5357 9.5667 36.021 11.7501C36.502 13.9146 36.6673 16.5405 36.6673 19.6667C36.6673 22.7928 36.502 25.4187 36.021 27.5832C35.5357 29.7667 34.7073 31.5813 33.3113 32.9773C31.9153 34.3733 30.1007 35.2017 27.9172 35.687C25.7527 36.168 23.1268 36.3333 20.0007 36.3333C16.8745 36.3333 14.2486 36.168 12.0841 35.687C9.90068 35.2017 8.08592 34.3733 6.68995 32.9773C5.29398 31.5813 4.4656 29.7667 3.98035 27.5832L4.95654 27.3662C5.4154 29.431 6.17698 31.0501 7.39707 32.2702C8.61713 33.4903 10.2363 34.2519 12.3011 34.7108C14.3581 35.1679 16.8974 35.3333 20.0007 35.3333C23.1039 35.3333 25.6432 35.1679 27.7002 34.7108C29.765 34.2519 31.3841 33.4903 32.6042 32.2702C33.8243 31.0501 34.5859 29.431 35.0448 27.3662C35.5019 25.3092 35.6673 22.7699 35.6673 19.6667C35.6673 16.5635 35.5019 14.0241 35.0448 11.9671Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4384_29992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9614 17.2646C12.9244 16.8922 12.7659 16.6029 12.4859 16.3967C12.2058 16.1905 11.8257 16.0874 11.3456 16.0874C11.0194 16.0874 10.7439 16.1335 10.5192 16.2259C10.2946 16.3151 10.1222 16.4397 10.0022 16.5998C9.88525 16.7598 9.82677 16.9414 9.82677 17.1445C9.82062 17.3138 9.85601 17.4615 9.93295 17.5877C10.013 17.7139 10.1222 17.8232 10.2607 17.9155C10.3992 18.0047 10.5593 18.0832 10.7408 18.1509C10.9224 18.2156 11.1163 18.271 11.3225 18.3171L12.1719 18.5202C12.5844 18.6126 12.9629 18.7357 13.3076 18.8896C13.6523 19.0434 13.9508 19.2327 14.2032 19.4574C14.4556 19.6821 14.651 19.9467 14.7895 20.2514C14.9311 20.5561 15.0034 20.9054 15.0065 21.2994C15.0034 21.878 14.8557 22.3796 14.5633 22.8043C14.274 23.226 13.8554 23.5537 13.3076 23.7876C12.7629 24.0185 12.1058 24.1339 11.3364 24.1339C10.5731 24.1339 9.90833 24.0169 9.34204 23.783C8.77883 23.5491 8.33873 23.2029 8.02173 22.7443C7.70781 22.2827 7.54316 21.7118 7.52777 21.0316H9.46207C9.48362 21.3486 9.57441 21.6133 9.73444 21.8256C9.89756 22.0349 10.1145 22.1934 10.3854 22.3011C10.6593 22.4058 10.9686 22.4581 11.3133 22.4581C11.6518 22.4581 11.9457 22.4089 12.195 22.3104C12.4474 22.2119 12.6428 22.0749 12.7813 21.8995C12.9198 21.7241 12.9891 21.5225 12.9891 21.2947C12.9891 21.0824 12.926 20.9039 12.7998 20.7592C12.6767 20.6146 12.4951 20.4915 12.255 20.3899C12.0181 20.2884 11.7272 20.196 11.3825 20.1129L10.3531 19.8544C9.55594 19.6605 8.92656 19.3574 8.46491 18.945C8.00327 18.5326 7.77398 17.977 7.77706 17.2784C7.77398 16.706 7.92632 16.2058 8.23409 15.7781C8.54493 15.3503 8.97119 15.0163 9.51285 14.7763C10.0545 14.5362 10.6701 14.4162 11.3594 14.4162C12.0611 14.4162 12.6736 14.5362 13.1968 14.7763C13.7231 15.0163 14.1324 15.3503 14.4248 15.7781C14.7172 16.2058 14.868 16.7013 14.8772 17.2646H12.9614ZM24.173 17.8555H22.151C22.114 17.5939 22.0386 17.3615 21.9248 17.1584C21.8109 16.9522 21.6647 16.7768 21.4862 16.6321C21.3077 16.4875 21.1015 16.3767 20.8676 16.2997C20.6368 16.2228 20.3859 16.1843 20.1151 16.1843C19.6258 16.1843 19.1995 16.3059 18.8363 16.549C18.4732 16.7891 18.1916 17.1399 17.9915 17.6016C17.7915 18.0601 17.6915 18.6172 17.6915 19.2727C17.6915 19.9467 17.7915 20.513 17.9915 20.9716C18.1946 21.4302 18.4778 21.7764 18.841 22.0103C19.2041 22.2442 19.6242 22.3612 20.1013 22.3612C20.369 22.3612 20.6168 22.3258 20.8445 22.255C21.0753 22.1842 21.28 22.0811 21.4585 21.9457C21.637 21.8072 21.7847 21.6394 21.9017 21.4425C22.0217 21.2455 22.1048 21.0208 22.151 20.7685L24.173 20.7777C24.1207 21.2116 23.9899 21.6302 23.7806 22.0334C23.5744 22.4335 23.2959 22.792 22.945 23.109C22.5972 23.4229 22.1817 23.6722 21.6986 23.8569C21.2184 24.0385 20.6752 24.1293 20.0689 24.1293C19.2257 24.1293 18.4716 23.9384 17.8069 23.5568C17.1452 23.1752 16.622 22.6228 16.2373 21.8995C15.8556 21.1763 15.6648 20.3007 15.6648 19.2727C15.6648 18.2417 15.8587 17.3646 16.2465 16.6413C16.6343 15.9181 17.1606 15.3672 17.8253 14.9886C18.4901 14.607 19.238 14.4162 20.0689 14.4162C20.6168 14.4162 21.1246 14.4931 21.5924 14.647C22.0633 14.8009 22.4803 15.0256 22.8434 15.321C23.2066 15.6134 23.5021 15.9719 23.7298 16.3967C23.9606 16.8214 24.1084 17.3076 24.173 17.8555ZM26.7945 14.5455L29.0797 21.7287H29.1674L31.4571 14.5455H33.673L30.4138 24H27.8378L24.574 14.5455H26.7945Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4384_29992",
    x: 1.33398,
    y: 1,
    width: 37.3333,
    height: 37.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_29992"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_29992",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4384_29992",
    x: 1.33398,
    y: 1,
    width: 37.3333,
    height: 37.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_29992"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_29992",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4384_29992",
    x: 5.09411,
    y: 14.4162,
    width: 31.0126,
    height: 14.585,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.43366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21683
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_29992"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_29992",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4384_29992",
    x1: 20.0007,
    y1: 3,
    x2: 20.0007,
    y2: 36.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C34BFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#830FB3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenCaptureVideo);
export default __webpack_public_path__ + "static/media/ScreenCaptureVideo.f0ba35969f022d1743ef741c67315c85.svg";
export { ForwardRef as ReactComponent };